import { lazy } from 'react';

import type { Policy } from '@cartwhl/common/appletPolicy';

import type { AppletDefinition } from '../../applets';
import CanvasLayout from '../CanvasLayout';
import CanvasLayoutAccessDenied from '../CanvasLayout/CanvasLayoutAccessDenied';
import CanvasLayoutLoading from '../CanvasLayout/CanvasLayoutLoading';

const MotionEditorRoute = lazy(() => import('./MotionEditorRoute'));

const applet = {
  id: 'motion-editor',
  path: '/motion-editor',
  paths: [
    '/motion-viewer',
    '/motion-viewer/create/:motionID',
    '/motion-viewer/:sceneID',
    '/motion-editor',
    '/motion-editor/create/:motionID',
    '/motion-editor/:sceneID',
  ],
  label: 'Motion Editor',
  description: 'Generative editing and reshaping',
  dashboard: {
    badge: 'New',
    videoSrc:
      'https://resources.getcartwheel.com/share/demo-videos/05_motion_editor_dashboard_output.webm',
    title: 'Motion Editor',
    description: 'Generative editing and reshaping',
    order: 25,
  },
  policy: {
    requiresAdmin: false,
    requiresApiKey: 'soft',
  } satisfies Policy,
  component: MotionEditorRoute,
  layout: CanvasLayout,
  loading: CanvasLayoutLoading,
  accessDenied: CanvasLayoutAccessDenied,
} satisfies AppletDefinition;

export default applet;
